import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wikitarot',
  templateUrl: './wikitarot.component.html',
  styleUrls: ['./wikitarot.component.scss']
})
export class WikitarotComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
